module.exports = __webpack_public_path__ + "static/hexowatch-home-441e3bca1f7fdfa09aa4aa7d5e925e9d.png";